import { ExternalLink, Mail, MapPin, Phone } from "lucide-react";
import { FaFacebook, FaInstagram, FaLinkedin, FaXTwitter } from "react-icons/fa6";
import { useWellKnown } from "../hooks/useWellKnown";
import "../styles/components/footer.css";

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const { data } = useWellKnown();

  return (
    <footer>
      <div>
        {data?.logo_url && (
          <img src={data.logo_url} alt={data.business_name ?? "Logo"} className="footer__logo-image" />
        )}
        {data?.description && <p className="footer__tagline">{data.description}</p>}
      </div>

      <div>
        <h3>Quick Links</h3>
        <ul>
{data?.website && (
            <li>
              <a href={data.website} target="_blank" rel="noopener noreferrer">
                <ExternalLink size={13} className="footer__icon" />
                Visit Website
              </a>
            </li>
          )}
        </ul>
      </div>

      <div>
        <h3>Contact</h3>
        <ul>
          {data?.support_email && (
            <li>
              <a href={`mailto:${data.support_email}`}>
                <Mail size={13} className="footer__icon" />
                {data.support_email}
              </a>
            </li>
          )}
          {data?.phone && (
            <li>
              <a href={`tel:${data.phone}`}>
                <Phone size={13} className="footer__icon" />
                {data.phone}
              </a>
            </li>
          )}
          {data?.address && (
            <li>
              <MapPin size={13} className="footer__icon" />
              {data.address}
            </li>
          )}
          {data?.facebook && (
            <li>
              <a href={data.facebook} target="_blank" rel="noopener noreferrer">
                <FaFacebook size={13} className="footer__icon" />
                Facebook
              </a>
            </li>
          )}
          {data?.twitter && (
            <li>
              <a href={data.twitter} target="_blank" rel="noopener noreferrer">
                <FaXTwitter size={13} className="footer__icon" />
                Twitter / X
              </a>
            </li>
          )}
          {data?.linkedin && (
            <li>
              <a href={data.linkedin} target="_blank" rel="noopener noreferrer">
                <FaLinkedin size={13} className="footer__icon" />
                LinkedIn
              </a>
            </li>
          )}
          {data?.instagram && (
            <li>
              <a href={data.instagram} target="_blank" rel="noopener noreferrer">
                <FaInstagram size={13} className="footer__icon" />
                Instagram
              </a>
            </li>
          )}
        </ul>
      </div>

      <div>
        <p>
          &copy; {currentYear} {data?.copyright_holder}. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
